const helpers: any = {
    scrollToComponent(target: Element) {
        const yCoordinate = target.getBoundingClientRect().top + window.pageYOffset
        const yOffset = -70

        window.scroll({
            top: yCoordinate + yOffset,
            behavior: 'smooth'
        })
    }
}

export default helpers
